import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

import "./index.scss";
import { IconButton, Typography } from "@mui/material";
import { exportToExcel } from "../../utils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const CustomBarChart = ({
  title,
  data = [],
  xDataKey,
  bDataKey,
  label = "Count",
  isHorizontal = false,
  height = 100,
  showLabel = true,
  tooltipFormatter,
  xAxisLabel,
  yAxisLabel,
}) => {
  const width = window.innerWidth > 420 ? 500 : 300;
  const labels = data.map((d) => d[xDataKey]);
  const options = {
    indexAxis: isHorizontal ? "y" : "x",
    legend: {
      display: false,
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            // If user provided a custom formatter, use it
            if (tooltipFormatter) {
              const item = data[tooltipItem.dataIndex];
              return tooltipFormatter(item, tooltipItem);
            }

            // Default behavior
            const item = data[tooltipItem.dataIndex];
            return `${label}: ${item[bDataKey]}`;
          },
        },
      },
      datalabels: {
        display: showLabel,
        color: "black",
        font: {
          weight: "bold",
        },
        formatter: (value) => {
          return value.toString().length > 2 ? "" : value;
        },
        anchor: "end",
        align: "top",
        offset: -1,
      },
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        title: {
          display: !!xAxisLabel,
          text: xAxisLabel || "",
          font: { size: 12, weight: "bold" },
        },
      },
      y: {
        grid: {
          display: true,
        },
        title: {
          display: !!yAxisLabel,
          text: yAxisLabel || "",
          font: { size: 12, weight: "bold" },
        },
      },
    },
  };
  const state = {
    labels,
    datasets: [
      {
        label: label,
        data: data.map((d) => d[bDataKey]),
        backgroundColor: "#005CE8",
        maxBarThickness: 30,
        barThickness: "flex",
      },
    ],
  };

  return (
    <div>
      <Typography variant="h6">{title}</Typography>

      {data.length > 0 ? (
        <Bar options={options} data={state} height={height} />
      ) : (
        <div
          style={{
            width: `${width}px`,
          }}
        >
          No data to display
        </div>
      )}
    </div>
  );
};

export default CustomBarChart;
